import { Component, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { Global } from '../classes/Global';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { Cache } from '../classes/Cache';
import { InfiniteScrollComponent } from '../classes/InfiniteScrollComponent';
import { WishlistService } from '../wishlist.service';
import { UrlValidator } from '../helpers/UrlValidater';
import { StorageHelper } from '../helpers/StorageHelper';
import { ModalComponent } from '../modal/modal.component';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';
import { SettingsService } from '../settings.service';
import { ListHelper } from '../helpers/ListHelper';
import { BrowserNavigationHelper } from '../helpers/BrowserNavigationHelper';
import { ThemeService } from '../theme.service';
import { GenresService } from '../genres.service';
import { CustomMap } from '../multipick-dropdown/multipick-dropdown.component';
import { PriceHelper } from '../helpers/PriceHelper';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss'],
  providers: [ WishlistService, GenresService ]
})
export class WishlistComponent extends InfiniteScrollComponent implements OnInit, AfterViewInit {

  static SORT_REDUCED_PRICE = "reducedInPrice";
  static SORT_ALPHABETIC = "alphabetical";
  static SORT_PRICE = "price";
  static SORT_ADDED_ON = "addedToWishlistAt";

  items;
  medias: Array<any>;
  selectedMediaType: string;
  mediaTypesForDisplay: Array<any>;
  mediaTypes: Array<any>;
  showSpinner = false;
  previousScrollY: number = -1;
  resultsEndReached = false;
  isLoading = false;
  showScrollToTopButton = false;
  sessionToken = "";
  showLoginMessage = false;
  itemToRemove = null;
  listIsEmpty = false;
  sortKey: string;
  status: string;
  sortingValues;
  statusValues;
  itemTypeValues;
  currentItemType: string;
  itemCountValue = 0;
  genres: CustomMap[] = [];
  selectedGenres: CustomMap[] = [];
  priceRanges: CustomMap[] = [];
  selectedPriceRanges: CustomMap[] = [];
  qualityOptions = [];
  selectedQuality;
  bundleFilterOptions = [];
  selectedBundleFilterOption;
  visionPro3dOptions = [];
  selectedVisionPro3dOption;

  @ViewChild("confirmRemoveFromWishListModal", {static: false}) confirmRemoveFromWishListModal;
  @ViewChild("authentication", {static: false}) authentication;
  @ViewChild('importDDContent', { static: false }) importDDContent: ElementRef;
  @ViewChild('exportDDContent', { static: false }) exportDDContent: ElementRef;
  @ViewChild('importIMDbListModal', {static: false}) importIMDbListModal;
  @ViewChild('importLetterboxdListModal', { static: false }) importLetterboxdListModal;
  @ViewChild('exportComingSoonModal', { static: false }) exportComingSoonModal;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      const targetElement = event.target as HTMLElement;
      let clickedInsideDropdown = false;
      try {
        clickedInsideDropdown = targetElement && targetElement.closest && targetElement.closest('.dropdown') !== null;
      } catch (e) {
        // Permission denied when accessing closest() from cross-origin iframe - ignore
        return;
      }
      if (!clickedInsideDropdown) {
        if (this.importDDContent) {
          this.closeDropdown(this.importDDContent);
        }
        if (this.exportDDContent) {
          this.closeDropdown(this.exportDDContent);
        }
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    private location: Location,
    private wishlistService: WishlistService,
    private settingsService: SettingsService,
    private themeService: ThemeService,
    private genresService: GenresService
  ) {
    super();
    this.initMediaTypes();
    this.sortingValues = [
      WishlistComponent.SORT_REDUCED_PRICE,
      WishlistComponent.SORT_ALPHABETIC,
      WishlistComponent.SORT_PRICE,
      WishlistComponent.SORT_ADDED_ON
    ];
    this.statusValues = ["all", "reduced", "waiting"];
    this.itemTypeValues = ["all", "buymovies", "rentalmovies"];
  }

  ngOnInit() {
    // Load more items at once on desktop devices
    if (window.innerWidth >= 1024) {
      this.limit = 36;
    }

    this.initWishlistViewState();

    UrlValidator.validateWishlistUrl(this.route, this.router);

    this.sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (this.sessionToken) {
      this.loadItems();
    }
    else {
      this.showLoginMessage = true;
    }
  }

  ngAfterViewInit() {
    this.setScrollPosition();
  }

  get itemCount(): number {
    return this.itemCountValue;
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  initMediaTypes(){

    this.mediaTypesForDisplay = Global.mediaTypesForSelector[Global.getStore()];

    this.mediaTypes = Global.supportedMediaTypes[Global.getStore()];
    //If we had a mediaType that doesn't exist in this new selected store,
    //choose the first one of the store
    if (this.mediaTypes && this.mediaTypes instanceof Array && this.mediaTypes.length > 0) {
      if (this.mediaTypes.indexOf(Global.getMediaType()) == -1) {
        this.mediaChanged(this.mediaTypes[0]);
      }
    }

    if (this.selectedMediaType == null) {
      this.selectedMediaType = Global.getMediaTypeForSelector();
    }

  }

  loadItems(url?: string) {
    // The url can be passed. It is necessary for the reload() function
    // because the router event is not called yet so the url in cache is wrong

    //First get data from cache, if it's missing, value = false
    //*****ALWAYS RELOAD THE WISHLIST FROM THE SERVER******/
    {
      this.loadGenreAndOffers(url);
    }
  }

  loadGenreAndOffers(url?: string) {
    if (!this.shouldLoadWishlistGenres()) {
      this.loadOffers();
      return;
    }

    const genresPresentInCache = this.loadGenresFromCache(url);
    if (genresPresentInCache) {
      this.loadOffers();
    }
    else {
      this.getGenres(this.loadOffers.bind(this));
    }
  }

  hideBecausePurchased(item): boolean {
    if (this.settingsService.hidePurchasedItems === true) {
      return ListHelper.isItemInOwnlist(item);
    }
    return false;
  }

  loadOffers() {
    this.offset = 0;
    this.resultsEndReached = false;
    this.showSpinner = true;
    this.isLoading = true;
    this.previousScrollY = -1;
    this.getOffers().subscribe(res => {

      if (res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        Global.clearSaveUserInfos();
        this.authentication.openLogin();
      }
      else if (res["results"]){

        this.items = res["results"][Global.getMediaTypeForWishlistRequest()];
        this.itemCountValue =
          res["totalItemCount"] && res["totalItemCount"][Global.getMediaTypeForWishlistRequest()]
            ? res["totalItemCount"][Global.getMediaTypeForWishlistRequest()]
            : 0;
        this.addToCache({ items: this.items, offset: this.offset });
      }
      this.showSpinner = false;
      this.isLoading = false;
      this.listIsEmpty = !this.items || this.items.length == 0;
      if (window.innerHeight > 1100) {
        this.loadMoreItems();
      }

    }, err => {
      this.showSpinner = false;
      Log.getInstance().d(err);
    });
  }

  loadMoreItems() {
    this.showSpinner = true;
    this.isLoading = true;
    this.offset += this.limit;
    this.getOffers().subscribe(res => {

      if (this.items && res["results"]){

        const newItems = res["results"][Global.getMediaTypeForWishlistRequest()];
        if (newItems) {
          this.items = this.items.concat(newItems);
          this.addToCache({ items: this.items, offset: this.offset });
        }
        if (!newItems || newItems.length === 0){
          this.resultsEndReached = true;
        }
        this.showSpinner = false;
        this.isLoading = false;
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

  addToCache(data: any, urlSpecification?: string){
    const cache = Cache.getInstance();
    let url = cache.getCurrentUrl(this);
    if (urlSpecification) { url = urlSpecification + "_" + url; }
    else { url = url + this.getFiltersString(); }
    cache.addData(url, data);
  }

  getFiltersString(): string {
    //This string combines all the filters to use in the cache key
    this.ensureWishlistFilterDefaults();
    const filtersString = this.sortKey + this.status + this.currentItemType +
      JSON.stringify(this.selectedGenres) + JSON.stringify(this.selectedPriceRanges) +
      this.selectedQuality["type"] + this.selectedBundleFilterOption["type"] +
      this.selectedVisionPro3dOption["type"];

    return filtersString;
  }

  reload(newUrl:boolean = false, replaceUrl?: boolean) {

    const url = [Global.getCountry(), Global.getStore(), this.getString(Global.getMediaTypeForWishlistRequest() + "Url"),this.getString("wishlistUrl")].join('/');
    const targetUrl = "/" + url;

    if (newUrl) {
      // Only navigate if URL actually changed to prevent excessive replaceState calls
      if (this.router.url !== targetUrl) {
        if (replaceUrl == true) {
          this.router.navigate([url], { replaceUrl: true });
        }
        else {
          this.router.navigate([url]);
        }
      }
    }

    if (newUrl) {
      this.loadItems("/" + url);
    }
    else {
      this.loadOffers();
    }
  }

  hardReload() {
    const url = [Global.getCountry(), Global.getStore(), this.getString(Global.getMediaTypeForWishlistRequest() + "Url"),this.getString("wishlistUrl")].join('/');
    this.router.navigate([url]);
    this.loadOffers();
  }

  getOffers() {
    let genreIds = "";
    let priceRange = "";
    let quality = "";
    let bundleFilter = "";
    let visionPro3d = "";

    if (this.shouldShowWishlistGenreFilter() && this.genres && this.genres.length > 0) {
      genreIds = this.formatMultiSelectionForServer(this.selectedGenres, this.genres);
    }
    if (this.shouldShowWishlistPriceFilter()) {
      priceRange = this.formatMultiSelectionForServer(this.selectedPriceRanges, this.priceRanges);
    }
    if (this.shouldShowWishlistQualityFilter()) {
      quality = this.getQualityForServer();
    }
    if (this.shouldShowWishlistVisionPro3dFilter()) {
      visionPro3d = this.getVisionPro3dForServer();
    }
    if (this.shouldShowWishlistBundleFilter()) {
      bundleFilter = this.getBundleFilterForServer();
    }

    return this.wishlistService.getDetailWishlist(Global.getCountry(), Global.getStore(),
      Global.getMediaTypeForWishlistRequest(), this.sessionToken, this.limit, this.offset, this.sortKey, this.status,
      this.currentItemType, genreIds, priceRange, quality, bundleFilter, visionPro3d);
  }

  shouldShowWishlistDetailFilters(): boolean {
    return this.shouldShowWishlistGenreFilter() || this.shouldShowWishlistPriceFilter() ||
      this.shouldShowWishlistQualityFilter() || this.shouldShowWishlistBundleFilter() ||
      this.shouldShowWishlistVisionPro3dFilter();
  }

  shouldLoadWishlistGenres(): boolean {
    const mediaTypes = Global.supportedMediaTypes[Global.getStore()];
    return mediaTypes && mediaTypes.indexOf(Global.getMediaType()) !== -1;
  }

  shouldShowWishlistGenreFilter(): boolean {
    return this.shouldLoadWishlistGenres() && this.genres && this.genres.length > 0;
  }

  shouldShowWishlistPriceFilter(): boolean {
    return this.priceRanges && this.priceRanges.length > 0 && this.getPriceRangeMediaType() !== "";
  }

  shouldShowWishlistQualityFilter(): boolean {
    return this.qualityOptions && this.qualityOptions.length > 1;
  }

  shouldShowWishlistVisionPro3dFilter(): boolean {
    return Global.getStore() === Global.ITUNES && Global.getMediaTypeForWishlistRequest() === Global.MOVIES;
  }

  shouldShowWishlistBundleFilter(): boolean {
    const store = Global.getStore();
    const isItunesOrVudu = store === Global.ITUNES || store === Global.VUDU;
    return isItunesOrVudu &&
      (Global.getMediaTypeForWishlistRequest() === Global.MOVIES || Global.getMediaTypeForWishlistRequest() === Global.TV);
  }

  shouldShowWishlistItemTypeFilter(): boolean {
    return Global.getMediaTypeForWishlistRequest() === Global.MOVIES;
  }

  initWishlistViewState() {
    this.initWishlistSort();
    this.initWishlistStatus();
    this.initWishlistItemType();
    this.initWishlistFilters();
  }

  initWishlistSort() {
    const savedSort = StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", StorageHelper.keys.sort);
    if (this.sortingValues && this.sortingValues instanceof Array && this.sortingValues.length > 0) {
      if (this.sortingValues.indexOf(savedSort) > -1) {
        this.sortKey = savedSort;
      }
      else {
        this.sortKey = this.sortingValues[0];
      }
    }
  }

  initWishlistStatus() {
    const savedStatus = StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", "status");
    if (this.statusValues && this.statusValues instanceof Array && this.statusValues.length > 0) {
      if (this.statusValues.indexOf(savedStatus) > -1) {
        this.status = savedStatus;
      }
      else {
        this.status = this.statusValues[0];
      }
    }
  }

  initWishlistItemType() {
    const savedItemType = StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", "itemType");
    if (this.itemTypeValues && this.itemTypeValues instanceof Array && this.itemTypeValues.length > 0) {
      if (this.shouldShowWishlistItemTypeFilter() && this.itemTypeValues.indexOf(savedItemType) > -1) {
        this.currentItemType = savedItemType;
      }
      else {
        this.currentItemType = this.itemTypeValues[0];
      }
    }
  }

  initWishlistFilters() {
    this.initGenre();
    this.initPriceRange(false);
    this.initQuality(false);
    this.initBundleFilter(false);
    this.initVisionPro3dFilter(false);
  }

  resetWishlistFilters() {
    this.initPriceRange(true);
    this.initQuality(true);
    this.initBundleFilter(true);
    this.initVisionPro3dFilter(true);
    this.selectedGenres = [this.getAllGenreItem()];
    StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
  }

  ensureWishlistFilterDefaults() {
    if (!this.selectedGenres || this.selectedGenres.length === 0) {
      this.selectedGenres = [this.getAllGenreItem()];
    }
    if (!this.selectedPriceRanges || this.selectedPriceRanges.length === 0) {
      this.selectedPriceRanges = [this.getAllPriceRangeItem()];
    }
    if (!this.selectedQuality) {
      this.selectedQuality = this.getQualityOptions()[0];
    }
    if (!this.selectedBundleFilterOption) {
      this.selectedBundleFilterOption = this.getBundleFilterOptions()[0];
    }
    if (!this.selectedVisionPro3dOption) {
      this.selectedVisionPro3dOption = this.getVisionPro3dOptions()[0];
    }
  }

  initGenre() {
    const savedGenres = this.getSavedGenres();
    if (savedGenres && savedGenres instanceof Array) {
      this.selectedGenres = savedGenres;
    }
    else {
      this.selectedGenres = [this.getAllGenreItem()];
    }
  }

  getGenres(callback?: () => void) {
    this.isLoading = true;
    this.showSpinner = true;
    return this.genresService.getGenres(Global.getStore(), Global.getCountry(), Global.getMediaType())
      .subscribe(res => {
        this.genres = [];
        if (res && res["results"]) {
          const genresFromServer = res["results"][Global.getGenreMediaType(Global.getMediaType())];
          if (genresFromServer) {
            this.genres = genresFromServer.map((g) => ({key: g.id, value: g.title}));
            if (this.genres && this.genres[0]) {
              this.genres[0].value = this.getString("all");
            }
          }
        }

        this.addToCache(this.genres, "genres");
        if (this.genres && this.genres.length > 0) {
          this.updateGenreSelection();
        }
        else {
          this.selectedGenres = [this.getAllGenreItem()];
        }

        if (callback) {
          callback();
        }
        else {
          this.isLoading = false;
          this.showSpinner = false;
        }
      }, err => {
        Log.getInstance().d(err);
        this.genres = [];
        this.selectedGenres = [this.getAllGenreItem()];
        if (callback) {
          callback();
        }
        else {
          this.isLoading = false;
          this.showSpinner = false;
        }
      });
  }

  loadGenresFromCache(url?: string): boolean {
    const cache = Cache.getInstance();
    if (!url) { url = cache.getCurrentUrl(this); }
    this.genres = cache.getData("genres_" + url);

    if (this.genres && this.genres.length > 0) {
      this.updateGenreSelection();
      return true;
    }
    return false;
  }

  updateGenreSelection() {
    const savedGenres: CustomMap[] = this.getSavedGenres();
    if (savedGenres && savedGenres instanceof Array && savedGenres.length > 0) {
      const validSavedGenres: CustomMap[] = [];
      for (const savedGenre of savedGenres) {
        const matchingGenre = this.getMatchingGenre(savedGenre);
        if (matchingGenre) {
          validSavedGenres.push(matchingGenre);
        }
      }

      if (validSavedGenres.length > 0) {
        this.selectedGenres = validSavedGenres;
        StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
      }
      else {
        this.selectedGenres = [this.getAllGenreItem()];
        StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
      }
    }
    else {
      this.selectedGenres = [this.getAllGenreItem()];
      StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
    }
  }

  getMatchingGenre(savedGenre: CustomMap): CustomMap {
    if (!savedGenre || savedGenre.key == null || !this.genres) {
      return null;
    }

    const savedGenreKey = savedGenre.key.toString();
    for (const genre of this.genres) {
      if (genre && genre.key != null && genre.key.toString() === savedGenreKey) {
        return genre;
      }
    }
    return null;
  }

  getSavedGenres() {
    return StorageHelper.getInstance().get(this.getGenreStorageKey());
  }

  getGenreStorageKey(): string {
    return StorageHelper.keys.genre + "_" + Global.getStore() +
      "_" + Global.getCountry() + "_" + Global.getMediaType() + "_wishlist";
  }

  getAllGenreItem(): CustomMap {
    if (this.genres && this.genres[0]) {
      return this.genres[0];
    }
    return {key: "0", value: this.getString("all")};
  }

  initPriceRange(reset: boolean) {
    this.priceRanges = this.getPriceRangeOptions();
    const priceRange = reset ? null : this.getSavedPriceRange();
    this.selectedPriceRanges = this.getValidMultiSelectionOrDefault(priceRange, this.priceRanges, this.getAllPriceRangeItem());
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.priceRange, this.selectedPriceRanges);
  }

  getValidMultiSelectionOrDefault(selectedItems: CustomMap[], allItems: CustomMap[], fallback: CustomMap): CustomMap[] {
    if (!selectedItems || !(selectedItems instanceof Array) || selectedItems.length === 0) {
      return [fallback];
    }

    const validItems: CustomMap[] = [];
    for (const selectedItem of selectedItems) {
      const matchingItem = this.getMatchingMultiSelectionItem(selectedItem, allItems, fallback);
      if (matchingItem) {
        validItems.push(matchingItem);
      }
    }

    return validItems.length > 0 ? validItems : [fallback];
  }

  getMatchingMultiSelectionItem(selectedItem: CustomMap, allItems: CustomMap[], fallback: CustomMap): CustomMap {
    if (!selectedItem || selectedItem.key == null) {
      return null;
    }
    if (fallback && fallback.key != null && selectedItem.key.toString() === fallback.key.toString()) {
      return fallback;
    }
    if (!allItems || !(allItems instanceof Array) || allItems.length === 0) {
      return null;
    }

    const selectedKey = selectedItem.key.toString();
    for (const item of allItems) {
      if (item && item.key != null && item.key.toString() === selectedKey) {
        return item;
      }
    }
    return null;
  }

  getAllPriceRangeItem(): CustomMap {
    return {key: "all", value: this.getString("all")};
  }

  getSavedPriceRange() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", StorageHelper.keys.priceRange);
  }

  getPriceRangeOptions(): Array<any> {
    const mediaForPriceRange = this.getPriceRangeMediaType();
    if (!mediaForPriceRange || !Global.priceRanges[mediaForPriceRange]) {
      return [];
    }

    let priceRange = Global.priceRanges[mediaForPriceRange][Global.getCountry()];
    if (!priceRange) {
      priceRange = Global.priceRanges[mediaForPriceRange]["us"];
    }
    if (!priceRange) {
      return [];
    }

    const priceRangesToReturn: any[] = [];
    priceRange.forEach(el => {
      if (el.key === "for") {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString("priceRange_for"),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: el.price.toFixed(2) });
      }
      else if (el.key === "under") {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString("priceRange_under"),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: "u" + el.price.toFixed(2) });
      }
      else if (el.key === "between") {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString("priceRange_between"),
          PriceHelper.formatPrice(el.price1,
            Global.countries[Global.getCountry()].currency, true, true, false),
          PriceHelper.formatPrice(el.price2,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: el.price1.toFixed(2) + "-" + el.price2.toFixed(2) });
      }
      else if (el.key === "over") {
        priceRangesToReturn.push({ value: StringHelper.format(
          this.getString("priceRange_over"),
          PriceHelper.formatPrice(el.price,
            Global.countries[Global.getCountry()].currency, true, true, false)),
        key: "o" + el.price.toFixed(2) });
      }
    });

    return priceRangesToReturn;
  }

  getPriceRangeMediaType(): string {
    if (Global.getMediaTypeForWishlistRequest() === Global.MOVIES) {
      if (this.currentItemType === Global.RENTALMOVIES) {
        return Global.RENTALMOVIES;
      }
      return Global.BUYMOVIES;
    }
    const mediaType = Global.getMediaType();
    return Global.priceRanges[mediaType] ? mediaType : "";
  }

  initQuality(reset: boolean) {
    this.qualityOptions = this.getQualityOptions();
    const savedQuality = reset ? null : this.getSavedQuality();
    this.selectedQuality = this.getValidOptionOrDefault(savedQuality, this.qualityOptions, "type");
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.quality, this.selectedQuality);
  }

  getValidOptionOrDefault(savedOption: any, options: Array<any>, property: string) {
    if (!options || !(options instanceof Array) || options.length === 0) {
      return null;
    }
    if (savedOption && typeof savedOption === "object" && savedOption[property] != null) {
      const savedValue = savedOption[property].toString();
      for (const option of options) {
        if (option && option[property] != null && option[property].toString() === savedValue) {
          return option;
        }
      }
    }
    return options[0];
  }

  getQualityOptions(): Array<any> {
    const allOption = {title: this.getString("all"), type: "all"};
    const mediaType = Global.getMediaTypeForWishlistRequest();
    const store = Global.getStore();
    const isMovies = mediaType === Global.MOVIES;
    const isTv = mediaType === Global.TV;

    if (!isMovies && !isTv) {
      return [allOption];
    }

    if (store === Global.ITUNES && isMovies) {
      return [
        allOption,
        {title: "SD", type: "sd"},
        {title: "HD", type: "hd"},
        {title: "4K", type: "4k"},
        {title: "HD/4K", type: "hd4k"}
      ];
    }

    if ((store === Global.VUDU && (isMovies || isTv)) || (store === Global.GOOGLEPLAY && isMovies)) {
      return [
        allOption,
        {title: "SD", type: "sd"},
        {title: "HD", type: "hd"},
        {title: "4K", type: "4k"}
      ];
    }

    if (store === Global.ITUNES && isTv) {
      return [
        {title: "HD/4K", type: "hd"},
        {title: "SD", type: "sd"},
        {title: "SD Only", type: "sdOnly"}
      ];
    }

    if (store === Global.AMAZON && (isMovies || isTv)) {
      return [
        allOption,
        {title: "SD", type: "sd"},
        {title: "HD", type: "hd"}
      ];
    }

    return [allOption];
  }

  getSavedQuality() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", StorageHelper.keys.quality);
  }

  getQualityForServer(): string {
    if (!this.selectedQuality || this.selectedQuality["type"] === this.getQualityOptions()[0]["type"]) {
      return "";
    }
    return this.selectedQuality["type"];
  }

  initBundleFilter(reset: boolean) {
    this.bundleFilterOptions = this.getBundleFilterOptions();
    const savedFilter = reset ? null : this.getSavedBundleFilter();
    this.selectedBundleFilterOption = this.getValidOptionOrDefault(savedFilter, this.bundleFilterOptions, "type");
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.showBundles, this.selectedBundleFilterOption);
  }

  getBundleFilterOptions(): Array<any> {
    const mediaType = Global.getMediaTypeForWishlistRequest();
    const onlyLabel = mediaType === Global.TV ? "seasonsOnly" : "moviesOnly";
    return [
      { title: "all", type: "all" },
      { title: "bundlesOnly", type: "1" },
      { title: onlyLabel, type: "0" }
    ];
  }

  getSavedBundleFilter() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist", StorageHelper.keys.showBundles);
  }

  getBundleFilterForServer(): string {
    if (!this.selectedBundleFilterOption ||
      this.selectedBundleFilterOption["type"] === this.getBundleFilterOptions()[0]["type"]) {
      return "";
    }
    return this.selectedBundleFilterOption["type"];
  }

  initVisionPro3dFilter(reset: boolean) {
    this.visionPro3dOptions = this.getVisionPro3dOptions();
    const savedFilter = reset ? null : this.getSavedVisionPro3dFilter();
    this.selectedVisionPro3dOption = this.getValidOptionOrDefault(savedFilter, this.visionPro3dOptions, "type");
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.visionPro3d, this.selectedVisionPro3dOption);
  }

  getVisionPro3dOptions(): Array<any> {
    return [
      { title: "all", type: "all" },
      { title: "movies3D", type: "visionPro3d" }
    ];
  }

  getSavedVisionPro3dFilter() {
    return StorageHelper.getInstance().getFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.visionPro3d);
  }

  getVisionPro3dForServer(): string {
    if (!this.selectedVisionPro3dOption ||
      this.selectedVisionPro3dOption["type"] === this.getVisionPro3dOptions()[0]["type"]) {
      return "";
    }
    return this.selectedVisionPro3dOption["type"];
  }

  formatMultiSelectionForServer(selectedItems: CustomMap[], allItems: CustomMap[]): string {
    if (!selectedItems || !allItems || !Array.isArray(selectedItems) || !Array.isArray(allItems)) {
      return "";
    }
    if (selectedItems.length === 0 || (selectedItems[0] &&
      (selectedItems[0].key === "all" ||
      (allItems[0] && selectedItems.length === 1 && selectedItems[0].key === allItems[0].key)))) {
      return "";
    }
    if (selectedItems.length === allItems.length && allItems.length > 0 && allItems[0]) {
      return "";
    }
    return selectedItems.map(x => x.key).sort().join();
  }

  back() {
    this.location.back();
  }

  storeChanged() {
    this.items = [];
    this.initMediaTypes();
    this.initWishlistViewState();
    this.reload(true);
  }

  mediaChanged(mediaType) {
    this.items = [];

    this.selectedMediaType = Global.getMediaTypeForSelector(mediaType);

    if (mediaType == "movies"){
      mediaType = Global.BUYMOVIES;
    }
    else if (mediaType == "music"){
      mediaType = "albums";
    }

    if (this.itemTypeValues && this.itemTypeValues instanceof Array && this.itemTypeValues.length > 0) {
      this.currentItemType = this.itemTypeValues[0];
    }

    StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
    this.initWishlistViewState();
    this.reload(true);
  }

  itemClicked(item){

    if (!item) {
      return;
    }

    this.saveScrollPosition();

    let itemType = Global.getMediaType();
    if (item.wishlistInfo && item.wishlistInfo.isMarkedAsRentalItem) {
      itemType = Global.RENTALMOVIES;
    }

    StorageHelper.getInstance().save(StorageHelper.keys.detailViewMediaType, itemType);

  }

  saveScrollPosition() {
    const cache = Cache.getInstance();
    cache.saveScrollPosition(this.router.url, window.scrollY);
  }

  setScrollPosition() {
    const cache = Cache.getInstance();
    const scrollPos = cache.getScrollPosition(this.router.url);
    cache.deleteScrollPosition(this.router.url); //To ensure that it is only used one time
    if (scrollPos) {
      window.scrollTo(0, scrollPos); //x, y
    }
  }

  removeFromWishlistClicked(item) {
    this.removeFromWishlist(item);
  }

  updateLocalShortWishlist(sessionToken: string) {
    this.wishlistService.getShortWishlist(
      Global.getCountry(),
      Global.getStore(),
      sessionToken
    ).subscribe(res => {

      if (res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openLogin();
      }
      else if (res && res["results"]) {
        const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
        shortWishlist[Global.getStore()] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        if (saved) {
          ListHelper.clearWishlistCache();
        } else {
          Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
        }
      }
    },
    err => {
      Log.getInstance().d(err);
    });
  }

  removeFromWishlist(item) {
    this.itemToRemove = null;
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
      if (sessionToken){

      let pluralItemType = Global.getPluralItemType(item.itemType);
      if (pluralItemType) {

        if (pluralItemType == "movies") { pluralItemType = "buymovies"; } //Cool Cool API

        const id = item.idInStore || item.itemID;

        this.wishlistService.removeItem(Global.getCountry(), Global.getStore(), pluralItemType,
          sessionToken, item.idInStore)
          .subscribe(res => {

            if (res && res["message"] == BaseService.COULDNT_LOAD_USER) {
              StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
              this.authentication.openLogin();
            }
            else {
              //Success!
              this.updateLocalShortWishlist(sessionToken);
              this.hardReload();
            }

          }, err => {
            Log.getInstance().d(err);
            this.updateLocalShortWishlist(sessionToken);
          });
        }
      }
  }

  onConfirmRemoveFromWishlistModalResult(result) {
    if (result == ModalComponent.RESULT_YES) {
      this.removeFromWishlist(this.itemToRemove);
    }
    else {
      this.itemToRemove = null;
    }
  }

  register() {
    this.authentication.openRegister();
  }

  login() {
    this.authentication.openLogin();
  }

  getStartPrice(item): number {

    if (!item) {
      return 0;
    }

    let startPrice;
    if (item && item.wishlistInfo) {
      if (item.wishlistInfo.isMarkedAsBuyItem == true) {
        if (item.wishlistInfo.initialBuyHdPriceValue) {
          startPrice = item.wishlistInfo.initialBuyHdPriceValue;
        }
        else {
          startPrice = item.wishlistInfo.initialBuySdPriceValue;
        }
      }
      else {
        if (item.wishlistInfo.initialRentalHdPriceValue) {
          startPrice = item.wishlistInfo.initialRentalHdPriceValue;
        }
        else {
          startPrice = item.wishlistInfo.initialRentalSdPriceValue;
        }

      }
    }

    return startPrice;
  }

  sortChanged(sortKey: string) {
    console.log("SORT CHANGED");
    this.sortKey = sortKey;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist", StorageHelper.keys.sort, sortKey);
    this.reload(false);
  }

  statusChanged(status: string) {
    this.status = status;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist", "status", status);
    this.reload(false);
  }

  itemTypeChanged(itemType: string) {
    this.currentItemType = itemType;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist", "itemType", itemType);
    this.initPriceRange(false);
    this.reload(false);
  }

  genreChanged(genreObj: CustomMap[]) {
    this.selectedGenres = genreObj;
    StorageHelper.getInstance().save(this.getGenreStorageKey(), this.selectedGenres);
    this.reload(false);
  }

  priceRangeChanged(priceRangeObj) {
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.priceRange, priceRangeObj);
    if (this.selectedPriceRanges && priceRangeObj && this.selectedPriceRanges[0] && priceRangeObj[0] &&
      this.selectedPriceRanges[0].key != priceRangeObj[0].key) {
      this.selectedPriceRanges = priceRangeObj;
      this.reload(false);
    }
  }

  qualityChanged(quality) {
    this.selectedQuality = quality;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.quality, quality);
    this.reload(false);
  }

  bundleFilterChanged(bundleFilterOption) {
    this.selectedBundleFilterOption = bundleFilterOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.showBundles, bundleFilterOption);
    this.reload(false);
  }

  visionPro3dChanged(visionPro3dOption) {
    this.selectedVisionPro3dOption = visionPro3dOption;
    StorageHelper.getInstance().saveFilter(Global.getStore(), Global.getMediaType(), "wishlist",
      StorageHelper.keys.visionPro3d, visionPro3dOption);
    this.reload(false);
  }

  storeIsItunes(): boolean {
    return Global.getStore() === Global.ITUNES;
  }

  isMoviesOrTv(): boolean {
    const media = Global.getMediaTypeForWishlistRequest();
    return media === Global.MOVIES || media === Global.TV;
  }

  showImportButton(): boolean {
    const store = Global.getStore();
    const isSupportedStore = store === Global.ITUNES || store === Global.AMAZON || store === Global.VUDU;
    return isSupportedStore && this.isMoviesOrTv();
  }

  importDropdownClicked() {
    if (this.importDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.importDDContent);
    } else {
      this.openDropdown(this.importDDContent);
    }
    // Close export dropdown if open
    if (this.exportDDContent) {
      this.closeDropdown(this.exportDDContent);
    }
  }

  exportDropdownClicked() {
    if (this.exportDDContent && this.exportDDContent.nativeElement) {
      if (this.exportDDContent.nativeElement.classList.contains('dd-open')) {
        this.closeDropdown(this.exportDDContent);
      } else {
        this.openDropdown(this.exportDDContent);
      }
    }
    // Close import dropdown if open
    if (this.importDDContent) {
      this.closeDropdown(this.importDDContent);
    }
  }

  isDropdownOpen(dropdownRef: ElementRef): boolean {
    return dropdownRef && dropdownRef.nativeElement && dropdownRef.nativeElement.classList.contains('dd-open');
  }

  closeDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-close';
    }
  }

  openDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-open';
    }
  }

  getMedia(): string {
    return this.getString(Global.getMediaTypeForWishlistRequest());
  }

  exportWithUrl() {
    // Close dropdown
    if (this.exportDDContent) {
      this.closeDropdown(this.exportDDContent);
    }

    if (!this.sessionToken) {
      Log.getInstance().d('No session token available for export');
      return;
    }

    const country = Global.getCountry();
    const store = Global.getStore();
    const mediaType = Global.getMediaTypeForWishlistRequest();

    const shareTab = BrowserNavigationHelper.openBlankTabForAsyncResult();

    this.wishlistService.getShareWishlistUrl(country, store, mediaType, this.sessionToken)
      .subscribe(res => {
        if (res && res.status === 'success' && res.additionalInfo && res.additionalInfo.shareURL) {
          const shareURL = res.additionalInfo.shareURL;
          BrowserNavigationHelper.navigateOpenedTabOrSameWindow(shareTab, shareURL);
        } else {
          BrowserNavigationHelper.closeTabIfOpen(shareTab);
          Log.getInstance().d('Failed to get share URL: ' + JSON.stringify(res));
        }
      }, err => {
        BrowserNavigationHelper.closeTabIfOpen(shareTab);
        Log.getInstance().d('Error getting share URL: ' + err);
      });
  }

  exportToCsv() {
    // Close dropdown
    if (this.exportDDContent) {
      this.closeDropdown(this.exportDDContent);
    }

    if (!this.sessionToken) {
      Log.getInstance().d('No session token available for export');
      return;
    }

    const country = Global.getCountry();
    const store = Global.getStore();
    const mediaType = Global.getMediaTypeForWishlistRequest();

    const shareTab = BrowserNavigationHelper.openBlankTabForAsyncResult();

    this.wishlistService.getShareWishlistUrl(country, store, mediaType, this.sessionToken)
      .subscribe(res => {
        if (res && res.status === 'success' && res.additionalInfo && res.additionalInfo.shareURL) {
          let shareURL = res.additionalInfo.shareURL;
          // Append action=exportCSV to the URL
          const separator = shareURL.indexOf('?') > -1 ? '&' : '?';
          shareURL = shareURL + separator + 'action=exportCSV';
          BrowserNavigationHelper.navigateOpenedTabOrSameWindow(shareTab, shareURL);
        } else {
          BrowserNavigationHelper.closeTabIfOpen(shareTab);
          Log.getInstance().d('Failed to get share URL: ' + JSON.stringify(res));
        }
      }, err => {
        BrowserNavigationHelper.closeTabIfOpen(shareTab);
        Log.getInstance().d('Error getting share URL: ' + err);
      });
  }

}
